// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"378":"c481d812","807":"7001e23c","976":"5139e4d4","1791":"c481d812","6433":"82020103"}[chunkId] + ".chunk.css";
};